import { useNavigate } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_metronic/helpers";
import { goToLink, HistoryCard } from "../projectData";
import { useEffect, useState } from "react";
import { getUserDashboard } from "../api";
import { useRouteData } from "../RouteDataContext";
/**
 * GreenplyDashboard component displays the main dashboard for Greenply users, including points, readiness, redemption, and history options.
 */
const GreenplyDashboard = ({ projectData }) => {
    const navigate = useNavigate();
    const { userData } = useRouteData();
    const [dashboard, setDashboard] = useState(null);

    useEffect(() => {
        if (userData && projectData) {
            getUserDashboard({ id: userData?.user?.iirpl_sap_code, project_key: projectData?.pkey }).then((d) => setDashboard(d?.data))
        }
    }, [userData, projectData])
    const containerStyle = {
        backgroundImage: `url(${toAbsoluteUrl('/media/images/uc.png')})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        boxShadow: '0px 1px 28px #0000000D'
    };
    return (
        <>
            < div className="container py-0 px-0">
                <div className=" bg-white p-6  py-2">
                    <div style={containerStyle} className=" rounded-2 px-6 py-3">
                        <div style={{ color: '#fff' }} className="m-0">
                            <div className="fw-semibolder fs-3">Welcome ,<span className="mb-4 ms-2 text-capitalize me-2" style={{ color: "#fff" }}>{userData?.user?.first_name} {userData?.user?.last_name}</span></div>
                            <div className="text-capitalize fs-6 fw-semibold">{userData?.user?.firm_name ? userData?.user?.firm_name : '--'}  </div>
                        </div>
                    </div>
                    <div className="mt-3"><div className="d-none mt-3 d-md-block">
                        <img
                            src={projectData?.banner ? toAbsoluteUrl(projectData?.banner) : ''}
                            alt="Banner"
                            className="w-lg-100  img-fluid "
                        />
                    </div>
                        <div className="d-block d-md-none">
                            <img
                                src={projectData?.banner ? toAbsoluteUrl(projectData?.banner) : ''}
                                alt="Banner"

                                className="img-fluid rounded  w-100"
                            />
                        </div>
                    </div>
                    <div className="mt-3">
                        {/* <h3>My Account</h3> */}
                        {/* <div className="pt-2">
                        <a onClick={() => goToLink(navigate, `/customer/redemption-voucher-history`, dashboard)}>
                  
                            <RedemnessReady status={dashboard?.redemReadness} />
                        </a>
                    </div> */}
                        <div className="row g-3 g-lg-6">

                            <div className="col-6">
                                <div style={{ backgroundColor: '#597445', boxShadow: '0px 1px 28px #0000000D' }} className=" d-flex justify-content-between align-items-center rounded-2 px-6 py-3">
                                    {/* <div className="symbol symbol-30px me-5 mb-8">
                                </div> */}
                                    <div style={{ color: '#fff' }} className="m-0">
                                        <span className=" fw-semibolder d-block fs-5  mb-1">{dashboard?.credit ? dashboard?.credit : '0'}</span>
                                        <span className="fw-semibold ">Total Points</span>
                                    </div>
                                    {/* <span className=""> <i className="bi text-white fs-3 fw-semibolder bi-chevron-right"></i></span> */}
                                </div>
                            </div>
                            <div className="col-6">
                                <div style={{ backgroundColor: '#295F98', boxShadow: '0px 1px 28px #0000000D' }} className=" rounded-2 px-6 py-3">
                                    <div style={{ color: '#fff' }} className="m-0">
                                        <div className="d-flex justify-content-between w-100">
                                            <span className=" fw-semibolder d-block fs-5 mb-1">{dashboard?.debit ? dashboard?.debit : '0'}</span>

                                        </div>
                                        <span className=" fw-semibold ">Redeemed  Points</span>
                                    </div>

                                </div>
                            </div>
                            <div className="col-12">
                                <div style={{ backgroundColor: '#B06161', boxShadow: '0px 1px 28px #0000000D' }} className=" d-flex justify-content-between align-items-center rounded-2 px-6 py-3">
                                    {/* <div className="symbol symbol-30px me-5 mb-8">
                                </div> */}
                                    <div style={{ color: '#fff' }} className="m-0">
                                        <span className=" fw-semibolder d-block fs-5  mb-1"> {dashboard?.totalBalance ? dashboard?.totalBalance : '0'}</span>
                                        <span className=" fw-semibold fs-6">Balance Points</span>
                                    </div>
                                    {/* <span className=""> <i style={{ color: "#6c757d" }} className="bi text-white fs-3 fw-semibolder bi-chevron-right"></i></span> */}
                                </div>
                            </div>
                            <div className="col-12">
                                <div className='card shadow-sm min-h-30px w-100' style={{ backgroundColor: "#FBF6F7", border: "1px solid #0000000D" }}
                                    onClick={() => goToLink(navigate, `/customer/redemptionness/${userData?.user?.iirpl_sap_code}`, dashboard)}
                                >
                                    <div style={{ borderRadius: '0px 7px 0px 6px', fontSize: '10px' }} className={`offer-label position-absolute fw-semibolder  top-0 end-0 p-1 ${Number(dashboard?.redemReadness) === 1 ? 'bg-success' : 'bg-danger'} bg-success text-white`}>
                                        {Number(dashboard?.redemReadness) === 1 ? 'Ready' : 'Not Ready'}
                                    </div>
                                    <div className='card-body p-5 py-4 d-flex justify-content-between align-items-center'>
                                        <div className='text-start d-flex align-items-center'>
                                            <div className='d-flex flex-column'>
                                                <div className='fw-semibold fs-5 text-dark'>Your Redemption Readiness </div>
                                                <div className=' fw-semibold w-100' style={{ color: "#717171" }}>You can add/edit PAN & Bank Details</div>
                                            </div>
                                        </div>
                                        <div className="d-inline-flex mt-3 align-items-center justify-content-center  rounded-circle" style={{ width: '20px', height: '20px', backgroundColor: "#000" }}>
                                            <i className="fas fa-chevron-right   text-white"></i>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='container bg-gray-200 pt-4'>
                    {/* {projectData?.special_message &&
                    <div class="notice d-flex bg-white rounded border-warning border mb-4 p-2 pt-3">
                        <span class="svg-icon svg-icon svg-icon-warning me-4 mt-1">
                            <div class="spinner-grow spinner-border-sm text-success" role="status">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </span>
                        <div class="d-flex flex-stack flex-grow-1">
                            <div class="fw-semibold">
                                <div class="fs-5 text-danger">{projectData?.special_message}</div>
                            </div>
                        </div>
                    </div>
                } */}

                    <div className='d-flex justify-content-between flex-wrap'>
                        <div className='card shadow-sm min-h-80px w-100' style={{ backgroundColor: "#fff", border: "1px solid #fff" }}
                            onClick={() => goToLink(navigate, `/customer/redem-category`, dashboard)}
                        >
                            <div className='card-body p-5 py-2 d-flex justify-content-between align-items-center'>
                                <div className='text-start d-flex align-items-center'>
                                    <img style={{ width: '40px' }} className="me-4" src={toAbsoluteUrl('/media/images/re-gift.png')} alt="re-gift" />
                                    <div className='d-flex flex-column'>
                                        <div className='fw-semibold  text-dark '>Redemption Center </div>
                                        <div className=' fw-semibold w-100' style={{ color: "#717171" }}>Click Here to Redeem Your Points</div>
                                    </div>
                                </div>
                                <div className="d-inline-flex align-items-center justify-content-center  rounded-circle" style={{ width: '20px', height: '20px', backgroundColor: "#597445" }}>
                                    <i className="fas fa-chevron-right   text-white"></i>
                                </div>

                            </div>


                        </div>
                    </div>
                    <div className="pt-4 pb-4  d-flex gap-2 ">

                        <HistoryCard
                            card_title="Redemption History"
                            card_text="View Redemption History"
                            backgroundColor="#295F98"
                            url='/customer/redemption-history'
                            dashboard={dashboard}
                        />


                        <HistoryCard
                            card_title="Redeemed Voucher"
                            card_text="Download Redeemed Voucher"
                            backgroundColor="#B06161"
                            url='/customer/redemption-voucher-history'
                            dashboard={dashboard}
                        />


                    </div>

                    {/* <div className="pt-2">
                    <a onClick={() => goToLink(navigate, `/customer/redemption-voucher-history`, dashboard)}>
                        <VoucherHistoryCard />
                    </a>
                </div> */}
                </div>
                {/* <WelcomePopup projectData={projectData} /> */}
            </div >

        </>
    )

}

export default GreenplyDashboard